// useOnlineStatus.js
import { useState, useEffect } from 'react';
import { AlertType } from '../components/shared/app-alert/app-alert.model';
import { appNote } from '../components/shared/constants';

const useOnlineStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowAlert(false);
        };

        const handleOffline = () => {
            setIsOnline(false);
            setShowAlert(true); 
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    const closeAlert = () => {
        setShowAlert(false);
    };

    const getAlertType = () => {
        return isOnline ? AlertType.NONE : AlertType.DISABLED;
    };

    const getAlertText = () => {
        return isOnline ? '' : appNote.OFFLINE_ALERT_TEXT;
    };

    return {
        isOnline,
        showAlert,
        alertType: getAlertType(),
        alertText: getAlertText(),
        closeAlert,
    };
};

export default useOnlineStatus;
